module.exports = __webpack_public_path__ + "img/7.18939604.png";